jQuery(document).ready(function ($) {

		// Initialize variables
		// let ajaxObject = ajax_object;
		// let current_page_myajax = 1;
		// console.log(ajaxObject);
		
		// // Function to load more cases
		// function loadMoreCases(isFirstLoad = false, category) {
		// 	console.log(category);
			
		// 		$.ajax({
		// 				url: ajaxObject.ajax_url,
		// 				data: {
		// 						'action': 'loadmore',
		// 						'paged': current_page_myajax,
		// 						'isFirstLoad': isFirstLoad,
		// 						'category': category
		// 				},
		// 				dataType: 'json',
		// 				type: 'POST',
		// 				success: function (res) {
		// 						if (res.html) {
									
    //                 let $newContent = $(res.html);
		// 								$.each($newContent, function (index, value) {
									
		// 									$(value).addClass('case-grid-item').appendTo('.case-grid-archive.grid.col-5');
					
		// 							});

    //               current_page_myajax++;

		// 						} else {
		// 								console.log('No more posts to load.');
		// 								$('.load-more-button').text('That\'s all folks!');
		// 						}
		// 				},
		// 				error: function (xhr, status, error) {
		// 						console.log('AJAX Error: ' + status + error);
		// 				}
		// 		});
		// }

		// Bind click event to the load more button
		// $('.load-more-button').click(function () {
		// 		loadMoreCases();
		// });

		// Load more cases based on clicked category
		// $('.case-category-item a').click(function (e) {
		// 		e.preventDefault();
		// 		let category = $(this).data('case');
		// 		loadMoreCases(false, category);
		// });

		// Load more cases on first load
		// loadMoreCases(true, false);


		// animate more-cases
		$('.more-cases-wrapper .case').on('mouseenter', function() {
			$(this).toggleClass('animate-grow');
			$(this).removeClass('animate-shrink');
		});

		$('.more-cases-wrapper .case').on('mouseleave', function() {
			$(this).toggleClass('animate-shrink');
			$(this).removeClass('animate-grow');
		});


		//  Apply isLit
		$('body.page-template-template-archive-case .case-categories li a').on('click', function(e) {
			
			e.preventDefault();
			$(this).toggleClass('isLit');
			

			
			let allLit = [];
			allLit = $('ul.case-categories li.clr-white a')
				.filter('.isLit')
				.map(function() {
					return $(this).data('case');
				})
				.toArray();
				
				// if none isLit, show all cases
				if (allLit.length === 0) {
					$('.case-grid-archive.grid.col-5 .case-grid-item').addClass('is-active');
					return;
				}
			
			let allCases = $('.case-grid-archive.grid.col-5 .case-grid-item');

			allCases.each(function() {
				let caseCategory = $(this).data('case');

				let caseCategoryArray = ( caseCategory ) ? caseCategory.split(' ') : [];		
				let hasMatch = false;
				hasMatch = caseCategoryArray.some(r => allLit.indexOf(r) >= 0);
				if (hasMatch) {
					$(this).addClass('is-active');
				} else {
					$(this).removeClass('is-active');
				}
			});
		});
				
});